module.exports = __webpack_public_path__ + "img/2019112004.71c6d440.jpg";